import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeGetPlayerProfileByUser } from 'store/selectors/player-profile-selectors'
import { ApplicationState } from 'store/types/common'

export const usePlayerProfile = (userId: number) => {
  const getPlayerProfile = useMemo(makeGetPlayerProfileByUser, [])
  return useSelector((state: ApplicationState) => getPlayerProfile(state, { userId }))
}
